import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../../api/supabase';

const statusColor = (s) => ({ CONFIRMED: 'badge-green', PENDING: 'badge-yellow', CANCELLED: 'badge-red', COMPLETED: 'badge-blue' }[s] || 'badge-gray');

export default function ClientDetail() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    supabase.from('clients').select('*').eq('id', id).single().then(({ data }) => setClient(data));
    supabase.from('bookings').select('*, packages(package_name)').eq('client_id', id).order('created_at', { ascending: false }).then(({ data }) => setBookings(data || []));
  }, [id]);

  if (!client) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">{client.full_name}</div>
          <div className="page-subtitle">{client.client_code}</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <Link to={`/clients/${id}/edit`} className="btn btn-secondary">Edit</Link>
          <Link to={`/ledger/clients`} state={{ clientId: id }} className="btn btn-secondary">📒 Ledger</Link>
          <Link to={`/bookings/new?client=${id}`} className="btn btn-primary">+ New Booking</Link>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16 }}>
        <div>
          <div className="card" style={{ marginBottom: 16 }}>
            <div className="card-title" style={{ marginBottom: 16 }}>Client Details</div>
            {[['Email', client.email], ['Phone', client.phone], ['Mobile', client.mobile], ['Passport', client.passport_number], ['Expiry', client.passport_expiry?.slice(0, 10)], ['Nationality', client.nationality], ['DOB', client.date_of_birth?.slice(0, 10)], ['City', client.city], ['Country', client.country]].map(([l, v]) => v ? (
              <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                <span style={{ color: 'var(--text-muted)' }}>{l}</span>
                <span style={{ fontWeight: 500 }}>{v}</span>
              </div>
            ) : null)}
          </div>

          {/* Audit info */}
          {(client.created_by || client.updated_by) && (
            <div className="card">
              <div className="card-title" style={{ marginBottom: 12 }}>Audit</div>
              {client.created_by && <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>Created by <strong>{client.created_by}</strong></div>}
              {client.updated_by && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Last edited by <strong>{client.updated_by}</strong> on {client.updated_at?.slice(0, 10)}</div>}
            </div>
          )}
        </div>

        <div className="card">
          <div className="card-header">
            <div className="card-title">Bookings ({bookings.length})</div>
          </div>
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Ref</th><th>Package</th><th>Travel Date</th><th>Status</th><th>Payment</th><th>Amount</th></tr></thead>
              <tbody>
                {bookings.map(b => (
                  <tr key={b.id}>
                    <td><Link to={`/bookings/${b.id}`} style={{ color: 'var(--primary)', textDecoration: 'none' }}>{b.booking_ref}</Link></td>
                    <td>{b.packages?.package_name || ''}</td>
                    <td>{b.travel_date?.slice(0, 10) || ''}</td>
                    <td><span className={`badge ${statusColor(b.booking_status)}`}>{b.booking_status}</span></td>
                    <td><span className={`badge ${b.payment_status === 'PAID' ? 'badge-green' : 'badge-yellow'}`}>{b.payment_status}</span></td>
                    <td className="amount">{b.sell_currency} {parseFloat(b.total_sell || 0).toLocaleString()}</td>
                  </tr>
                ))}
                {bookings.length === 0 && <tr><td colSpan={6} style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 20 }}>No bookings yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
